<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <!-- <el-form-item>
        <el-input placeholder="请输入视频标题"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请选择发布状态"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请选择时间"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search"></el-button>
      </el-form-item>-->
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="dialogVisable=true,videoParam={},dialogTitle='添加视频'">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="videoList" border stripe :cell-class-name="cellstyle">
      <el-table-column type="index" width="80" align="center" label="序号"></el-table-column>
      <el-table-column align="center" prop="movieName" label="视频标题"></el-table-column>
      <el-table-column align="center" label="视频" width="180">
        <template slot-scope="scope">
          <div class="playable">
            <div class="episode-cover" @click="videoWatching(scope.row)">
              <img :src="scope.row.url" alt width="180" />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop label="操作" style="padding:0px">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="delMovie(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="searchModel.pageNo"
      @current-change="getMovieList"
      :page-size="searchModel.pageSize"
      layout="prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisable">
      <el-form ref="form" label-width="90px">
        <el-form-item label="视频标题">
          <el-input v-model="videoParam.movieName"></el-input>
        </el-form-item>
        <el-form-item label="视频地址">
          <el-upload
            class="upload-demo"
            action="/file/upload"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
            :on-success="handleSuccess"
            :headers="headers"
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
          <!-- <el-input v-model="videoParam.movieUrl" placeholder="请输入视频地址"></el-input> -->
        </el-form-item>
        <el-form-item label="视频顺序">
          <el-input-number v-model="videoParam.movieOrder"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>
    <div class="player" v-if="videoWatch">
      <div class="player__content">
        <a href="javascript:;" @click="cancelWatch" class="close">X</a>
        <div class="player__screen">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          ></video-player>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as videoApi from '@/api/adminApi/zh/video';
import { localStorage } from '@/common/util/storage';
export default {
  data() {
    return {
      headers: {
        token: localStorage.get('token')
      },
      fileList: [],
      total: 0,
      dialogVisable: false,
      dialogTitle: '添加视频',
      videoWatch: false,
      videoParam: {},
      searchModel: {
        pageNo: 1,
        pageSize: 10
      },
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '' // url地址
          }
        ],
        poster: '../../static/images/test.jpg', // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //  全屏按钮
        }
      },
      videoList: []
    };
  },
  methods: {
    getMovieList() {
      videoApi.getMovieList(this.searchModel).then(res => {
        this.videoList = res.data.list;
        this.total = res.data.pageTotal;
      });
    },
    delMovie(row) {
      this.$confirm('是否确认删除该视频', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          videoApi.delMovie({ movieId: row.movieId }).then(res => {
            this.getMovieList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    handleRemove() {},
    cellstyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex === 2) {
        return 'video_cell';
      }
    },
    cancelWatch() {
      this.videoWatch = false;
    },
    edit(row) {
      this.videoParam = JSON.parse(JSON.stringify(row));
      this.dialogTitle = '编辑视频';
      this.dialogVisable = true;
    },
    update() {
      if (this.videoParam.movieId) {
        videoApi.upMovie(this.videoParam).then(res => {
          this.getMovieList();
          this.videoParam = {};
          this.dialogVisable = false;
          this.dialogTitle = '添加视频';
        });
      } else {
        videoApi.addMovie(this.videoParam).then(res => {
          this.videoParam = {};
          this.getMovieList();
          this.dialogVisable = false;
        });
      }
    },
    handleSuccess(res, file) {
      this.videoParam.movieUrl = res.realpath;
    },
    videoWatching(item) {
      this.$set(this.playerOptions.sources[0], 'src', item.movieUrl);
      this.$set(this.playerOptions, 'poster', item.movieUrl);
      this.videoWatch = true;
    }
  },
  created() {
    this.getMovieList();
  }
};
</script>
<style lang="stylus" scoped>
.playable {
  cursor: pointer;
}

.player {
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .player__content {
    box-shadow: 0 0 100px #000;
    position: relative;
    z-index: 1;
    left: 50%;
    top: 50%;
    margin-left: -400px;
    margin-top: -225px;
    background-color: #fff;
    border-radius: 3px;
    width: 800px;
    height: 450px;
    border: solid 1px #000;

    .close {
      font-size: 12px;
      padding: 10px;
      color: #FFF;
      position: absolute;
      z-index: 2;
      right: 1px;
      top: 1px;
      border: none;

      &:hover {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }

    .player__episode {
      display: none;
      position: absolute;
      left: 100%;
      top: -1px;
      bottom: -1px;
      width: 170px;
      background-color: rgba(0, 0, 0, 0.7);
      border: solid 1px #000;
      border-radius: 3px;
      color: #FFF;
      font-size: 14px;

      .player-episode__title {
        font-size: 14px;
        padding: 10px 10px 0;
        color: #999;
      }

      .player-episode__body {
        margin: 0;
        padding: 0;
        list-style: none;
        overflow: auto;
        height: 420px;

        li {
          padding: 10px 20px;
          margin: 0;
          position: relative;
          cursor: pointer;

          &:hover {
            background-color: rgba(0, 0, 0, 0.7);

            &:after {
              display: none;
            }
          }

          &:after {
            content: '';
            display: block;
            position: absolute;
            left: 10px;
            right: 10px;
            bottom: 0;
            border-bottom: 1px solid #222;
          }

          &:last-child:after {
            display: none;
          }

          .episode-title {
            padding-bottom: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }

          span {
            color: #999;
            font-size: 12px;
            margin-right: 5px;
            cursor: default;

            &.episode-time:before {
              padding-right: 3px;
              font-family: 'iconfont';
              content: '\e70b';
            }

            &.episode-clock:before {
              padding-right: 3px;
              font-family: 'iconfont';
              content: '\e63e';
            }

            &:hover {
              color: #AAA;
            }
          }
        }
      }
    }

    &:hover {
      border-radius: 2px 0 0 2px;

      .player__episode {
        display: block;
        border-radius: 0 2px 2px 0;
      }
    }
  }
}

.playable {
  &:hover .episode-cover:before {
    background-color: rgba(0, 0, 0, 0.7);
  }
}

.episode-cover {
  &:before {
    font-family: 'iconfont';
    content: '\e64c';
    display: block;
    position: absolute;
    width: 100%;
    height: 113px;
    line-height: 113px;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.1);
    color: #FFF;
    font-size: 36px;
  }

  img {
    width: 100%;
    height: 113px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/video/list.vue